export const static_items = 'static_items';
export const static_workLevel = 'static_worklevel';
export const static_items_id = 'cb4ceff4-8a06-4f87-8d9b-ce0e237cd441';
export const static_worklevel_id = '894316c7-f932-48fa-8fe4-5c41f8d1daf8';
